import 'react-app-polyfill/stable';
// swing in the app was conflicting with swing 
// import 'swing-ui/dist/css/swing.min.css';
import './assets/css/variables.css';
import './assets/css/app.css';
import React from 'react';
import ReactDOM from 'react-dom/client';
import App from "./components/App/App";
// import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('mysponsoredchildapp'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
// reportWebVitals();
